import { render, staticRenderFns } from "./PublicEventView.vue?vue&type=template&id=2d700345&scoped=true&"
import script from "./PublicEventView.vue?vue&type=script&lang=ts&"
export * from "./PublicEventView.vue?vue&type=script&lang=ts&"
import style0 from "./PublicEventView.vue?vue&type=style&index=0&id=2d700345&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d700345",
  null
  
)

export default component.exports